import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type ChangeChargesProjectMutationVariables = Types.Exact<{
  input: Types.ChangeProjectChargesProjectCommand;
}>;


export type ChangeChargesProjectMutation = { __typename?: 'MutationModel', projectCharges: { __typename?: 'ProjectChargesMutationModel', changeProject: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const ChangeChargesProjectDocument = gql`
    mutation ChangeChargesProject($input: ChangeProjectChargesProjectCommand!) {
  projectCharges {
    changeProject(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type ChangeChargesProjectMutationFn = Apollo.MutationFunction<ChangeChargesProjectMutation, ChangeChargesProjectMutationVariables>;

/**
 * __useChangeChargesProjectMutation__
 *
 * To run a mutation, you first call `useChangeChargesProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeChargesProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeChargesProjectMutation, { data, loading, error }] = useChangeChargesProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeChargesProjectMutation(baseOptions?: Apollo.MutationHookOptions<ChangeChargesProjectMutation, ChangeChargesProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeChargesProjectMutation, ChangeChargesProjectMutationVariables>(ChangeChargesProjectDocument, options);
      }
export type ChangeChargesProjectMutationHookResult = ReturnType<typeof useChangeChargesProjectMutation>;
export type ChangeChargesProjectMutationResult = Apollo.MutationResult<ChangeChargesProjectMutation>;
export type ChangeChargesProjectMutationOptions = Apollo.BaseMutationOptions<ChangeChargesProjectMutation, ChangeChargesProjectMutationVariables>;